<template>
    <div class="view-contactCreate">
        <div class="contactCreate scroll-container">
            <div class="casTips">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/member/yTipsIcon.png">
                <span>系统未匹配到您的会员信息，建议您创建新的会员号</span>
            </div>
            <div class="contactCreate-list">
                <div class="passenger-detail-desc">
                    <div class="detail-title">
                        <div class="detail-text">加入皇冠铁锚俱乐部累积航行里程</div>
                    </div>
                    <div class="passenger-content">
                        <div class="passenger-family">手机号</div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" :value="telephone" id="mobile" class="firstNamePY" disabled="">
                        </div>
                    </div>
                    <div class="passenger-content">
                        <div class="passenger-family">姓拼音</div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" id="lastName" class="lastNamePY" v-model="lastName">
                        </div>
                    </div>

                    <div class="passenger-content">
                        <div class="passenger-family">名拼音</div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" id="firstName" class="firstNamePY" v-model="firstName">
                        </div>
                    </div>
                    
                    <div class="passenger-content passenger-birthDate">
                        <div class="passenger-family">出生日期</div>
                        <div class="passenger-txt">
                            <input type="date" placeholder="必填" value="" id="birthDate" class="birthOfDate input-text-left" v-model="dateOfBirth">
                        </div>
                        <img src="https://resource.rcclchina.com.cn/tui2/user_center/calender-icon.png">
                    </div>

                    <div class="passenger-content">
                        <div class="passenger-family">电子邮箱<span class="tips">*</span></div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" value="603212227@qq.com" id="email" class="email" v-model="email">
                            <img class="clear_icon" src="https://resource.rcclchina.com.cn/tui2/user_center/delete_icon.png">
                        </div>
                    </div>

                    <div class="passenger-content">
                        <div class="passenger-family">密码</div>
                        <div class="passenger-txt">
                            <input type="password" placeholder="必填" value="" id="password" class="password" v-model="password">
                        </div>
                    </div>

                </div>
            </div>

            <div class="contactCreate-addGuestBtn" id="infoSubmitBtn" @click="submit()">即刻加入</div>
            <div class="goBack" @click="goBack()">
                <a class="external" >稍后加入</a>
            </div>

            <div class="tips-description">
                <p>
                    *邮箱地址将用于发送重要确认信息，请务必准确填写。
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "CreateCas",
    data () {
        return {
            lastName: '',
            firstName: '',
            dateOfBirth: '1980-01-01',
            email: '',
            password: ''
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '升级会员')
    },
    mounted() {
        const userToken = this.$store.state.user.userToken
        if (!userToken || userToken.length == 0) {
            return this.$router.push({ name: 'Login', query:{ 
                returnUrl: location.href
            }})
        } 
    },
    methods: {
        goBack() {
            const query = this.$router.currentRoute.query
            if (query.returnUrl && query.returnUrl.length > 0) {
                location.href = query.returnUrl
            } else {
                this.$router.push('/Rccl.UserCenter/CustomerInfo/Info')
            }
        },
        async submit() {
            if (!this.checkForm()) return
            
            let requestData = {
                lastNamePinYin: this.lastName,
                firstNamePinYin: this.firstName,
                dateOfBirth: this.dateOfBirth,
                email: this.email,
                password: this.password
            }
            
            this.$loading.show()
            const { success, errMsg } = await api.user.createCas(requestData)
            this.$loading.hide()
            if (success) {
                return this.goBack()
            } else {
                this.$alert.show(errMsg)
            }
        },
        checkForm() {
            if (!this.lastName || this.lastName.length == 0) {
                this.$alert.show('请输入姓拼音')
                return false
            } else if (!this.firstName || this.firstName.length == 0) {
                this.$alert.show('请输入名拼音')
                return false
            } else if (!this.dateOfBirth || this.dateOfBirth.length == 0) {
                this.$alert.show('请输入出生日期')
                return false
            } else if (!this.email || this.email.length == 0) {
                this.$alert.show('请输入邮箱')
                return false
            } else if (!this.password || this.password.length == 0) {
                this.$alert.show('请输入密码')
                return false
            }

            return true
        }
    },
    computed: {
        telephone () {
            const userInfo = this.$store.state.user.userInfo
            if (!userInfo || !userInfo.mobile) return ''
            return userInfo.mobile
        }
    }
}
</script>

<style lang="less" scoped>

/**** 
 黄色：#eead11
****/


/**** 常用联系人添加页面****/
.view-contactCreate .noborder {
    border: none !important;
}

.view-contactCreate .page-content {
    margin-top: 50px;
    padding-bottom: 8.2rem;
    background-color: #f1f1f1;
    position: relative;
}

.view-contactCreate nav.home-bar-nav {
    background-color: #061556;
}

.view-contactCreate .contactCreate-list {
    background-color: #fff;
    padding: 0 12px;
}

    .view-contactCreate .contactCreate-list ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

        .view-contactCreate .contactCreate-list ul li {
            border-bottom: 1px solid #e0e0e0;
            padding: 13px 11px;
        }

    .view-contactCreate .contactCreate-list .contactCreate-item {
        position: relative;
    }

        .view-contactCreate .contactCreate-list .contactCreate-item span {
            font-size: 13px;
            color: #989898;
        }

        .view-contactCreate .contactCreate-list .contactCreate-item input {
            margin-left: 20px;
            font-size: 13px;
            color: #000;
            padding: 6px 0;
            text-indent: 4px;
            border: none;
            outline: none;
            -webkit-appearance: none;
            background-color: transparent;
        }

input.birthOfDate {
    width: 240px;
    position: relative;
    z-index: 1;
}

input.passportDate {
    width: 190px;
    position: relative;
    z-index: 1;
}

.view-contactCreate .contactCreate-list .contactCreate-item input::-webkit-input-placeholder {
    color: #999999;
}

.view-contactCreate .contactCreate-list .contactCreate-item .calendarIcon {
    position: absolute;
    right: 15px;
    top: 0;
    width: 24px;
    height: 24px;
}

    .view-contactCreate .contactCreate-list .contactCreate-item .calendarIcon img {
        width: 100%;
    }

.view-contactCreate .contactCreate-list .contactCreate-item .contactCreate-itemSex {
    margin-right: 32px;
}

.view-contactCreate .contactCreate-list .contactCreate-item .item-sex {
    margin-right: 41px;
}

.view-contactCreate .contactCreate-list .contactCreate-item .item-sex {
    color: #000;
}

    .view-contactCreate .contactCreate-list .contactCreate-item .item-sex .f7-icons {
        color: #7e7e7e !important;
        font-size: 21px !important;
        vertical-align: top;
        margin-right: 11px;
    }

        .view-contactCreate .contactCreate-list .contactCreate-item .item-sex .f7-icons.active {
            color: #0073a0 !important;
        }

.view-contactCreate .contactCreate-addGuestBtn {
    background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
    font-family: PingFang-SC-Medium;
    font-size: 16px;
    color: #454545;
    letter-spacing: 2.5px;
    padding: 11px 0;
    margin: 10px 0px 0 0px;
    text-align: center;
    position: relative;
}

/**** 20180705 ****/
.passenger-detail-desc {
    background: #fff;
    padding: 0 10px;
    position: relative;
}

.passenger-content {
    width: 100%;
    border-bottom: 1px solid rgba(216,216,216,0.6);
    padding: 10px 0;
    position: relative;
    font-size: 14px;
}

.passenger-content .passenger-txt {
    margin-left: 10px;
}

.passenger-content .passenger-txt input {
    padding-left: 20px;
}

    .passenger-content .passenger-family,
    .passenger-content .passenger-txt {
        display: inline-block;
        font-size: 14px;
        height: 35px;
        line-height: 37px;
    }

input::-webkit-input-placeholder {
    color: #999;
}

.passenger-content .passenger-family {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    max-width: 141px;
    overflow: hidden;
    vertical-align: top;
}

.passenger-content .passenger-txt input {
    color: #000;
    outline: none;
    border: none;
    height: 35px;
    width: 250px;
    background-color: transparent;
    -webkit-appearance: none;
    position: relative;
    z-index: 1;
    text-align: left;
}

    .passenger-content .passenger-txt input.lastName,
    .passenger-content .passenger-txt input.firstName,
    .passenger-content .passenger-txt input.lastNamePY,
    .passenger-content .passenger-txt input.firstNamePY {
        width: 200px;
        height: 35px;
        overflow: hidden;
    }

    .passenger-content .passenger-txt input.birth-date {
        width: 224px;
    }

.passenger-optional .optionalTxt {
    text-align: center;
    font-size: 12px;
    padding: 10px 0;
    font-family: PingFang-SC-Medium;
    color: #999999;
    letter-spacing: 0.86px;
}

.optionalTxt.active .optionTxt-close, .optionalTxt .optionTxt-open {
    display: none;
}

.optionalTxt .optionTxt-close, .optionalTxt.active .optionTxt-open {
    display: block
}

.optionalTxt img {
    width: 11px;
    position: relative;
}

.optionTxt-open img {
    transform: rotate(180deg);
    top: -2px;
}

.passenger-content .passenger-txt input#contacts-address {
    width: 230px;
}

.passenger-content .passenger-txt .passport-validity {
    width: 220px;
}

.passenger-txt .male-txt,
.passenger-txt .female-txt {
    display: inline-block;
}

    .passenger-txt .male-txt i,
    .passenger-txt .female-txt i {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url("https://resource.rcclchina.com.cn/tui2/user_center/list-unselected.png") no-repeat;
        vertical-align: middle;
        background-size: 100% 100%;
        position: relative;
        top: -1px;
    }

.passenger-content .passenger-male {
    padding-left: 36px;
}

.passenger-placeholder {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0.86px;
}

.passenger-male .passenger-placeholder {
    margin-left: 34px;
    display: inline-block;
    vertical-align: middle;
}

.passenger-txt .male-txt span,
.passenger-txt .female-txt span {
    margin-left: 10px;
}

.passenger-birthDate,
.passenger-pssport {
    position: relative;
}

.passenger-txt .male-txt {
    margin-right: 30px;
}

.passenger-content .passenger-txt .active i {
    background: url("https://resource.rcclchina.com.cn/tui2/user_center/list-selected.png") no-repeat;
    background-size: 100% 100%;
}

.passenger-birthDate img,
.passenger-pssport img {
    width: 20px;
    position: absolute;
    top: 16px;
    right: 5px;
    z-index: 0;
}

#pinyinBtn {
    background: #fff;
    color: #006bb9;
    padding: 5px;
    border: 1px solid;
    border-radius: 6px;
    font-size: 12px;
    width: 50px;
    text-align: center;
    position: absolute;
    top: 13px;
    right: 10px;
}
/****---- 清空护照号 ----****/
.passportClearBtn {
    color: #006bb9;
    border: 1px solid;
    border-radius: 6px;
    font-size: 12px;
    width: 46px;
    line-height: 28px;
    text-align: center;
    position: absolute;
    top: 13px;
    right: 10px;
}

.passenger-content .passenger-txt input.birthOfDate {
    width: 260px;
    padding-left: 6px;
}

.passenger-content .passenger-txt .input-text-left {
    text-align: left;
    /* padding-left: 20px; */
}

.passenger-content .passenger-txt .passportDate {
    width: 242px;
}

.passenger-content .passenger-txt .passportNum {
    padding-left: 35px;
}

.passenger-content .passenger-txt .vipNum {
    padding-left: 8px;
}

.passenger-content .passenger-txt input.email {
    padding-left: 8px;
}

.passenger-content .passenger-txt input.password {
    padding-left: 38px;
}

/**** 省市地址 ****/
.passenger-content select {
    width: 140px;
    display: inline-block;
    border: none;
    /*border-bottom: 1px solid #d5d2d2;*/
    font-size: 13px;
    text-indent: 10px;
    appearance: menulist-button;
    -webkit-appearance: menulist-button;
    -moz-appearance: menulist-button;
    font-weight: bold;
}

.passenger-content select {
    width: 128px;
    vertical-align: -webkit-baseline-middle;
    background-color: transparent;
}

.passenger-content .contacts-address {
    font-size: 13px;
    border: none;
    width: 100%;
    padding-left: 88px;
}


/**contact default**/
.contact-default {
    background-color: white;
    margin-top: 9px;
    width: 100%;
    height: 50px;
    padding: 16px 20px;
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
}


    .contact-default > div {
        display: inline-block;
        vertical-align: top;
        position: relative;
    }

.contact-default-switch {
    float: right;
}

.contact-default-title {
    top: -2px;
}


/*toggle switch*/
/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 31px;
    height: 16px;
}

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
}

    .slider:before {
        position: absolute;
        content: "";
        height: 15px;
        width: 15px;
        left: -2px;
        bottom: -1px;
        -webkit-transition: .4s;
        transition: .4s;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        box-shadow: 0 1px 2.5px 0 rgba(0,0,0,0.30);
    }

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

    .slider.round:before {
        border-radius: 50%;
    }

.detail-title {
    padding: 10px;
    font-size: 15px;
    text-align: center;
    line-height: 23px;
    letter-spacing: 1px;
}

.detail-title .detail-text-tips {
    color: #F4BF44;
    font-weight: 400;
}

.goBack {
    text-align: center;
    margin-top: 10px;
}

.goBack a {
    text-align: center;
    color:#333333;
    font-size: 12px;
    text-decoration: underline;
    letter-spacing: 2px;
}

.tips-description{
    margin-top: 25px;
    padding: 0px 25px;
    color:#333333;
    font-size: 12px;

}

.casTips {
    padding: 10px 15px;
    letter-spacing: 1px;
    color: #FF5055;
    font-size: 12px;
    text-align: center;
}

.casTips img {
    width: 12px;
}

.clear_icon {
    width: 12px;
    position: absolute;
    top: 22px;
    right: 7px;
    z-index:3;
}
</style>